
import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
// import { IoArrowForward } from "react-icons/io5";
import { IoArrowBack, IoTrendingUpSharp } from "react-icons/io5";
import { BsStarFill, BsStarHalf, BsStar } from "react-icons/bs";
import { BiCheckShield } from "react-icons/bi";

import { FaStar, FaChevronRight, FaChevronLeft, FaUserAlt, FaMapMarkerAlt, FaWallet, FaRegBuilding } from "react-icons/fa";

// import ArrowPrevious from "./arrow-previous.svg";
import ArrowPrevious from './../Images/home.png';
// import ArrowNext from "./arrow-next.svg";
import user_1 from './../Images/user-1.png';

const PrevButton = ({ onClick }) => {
    return (
        <button
            className="previous-btn test-prev"
            onClick={onClick}
        // style={{ backgroundColor: "transparent", border: "none" }}
        >
           <FaChevronLeft />  Previous 
        </button>
    );
};
const NextButton = ({ onClick }) => {
    return (
        <button
            className="next-btn test-next"
            onClick={onClick}

        >
            Next <FaChevronRight />

        </button>
    );
};
const ArrowButton = ({ imgSrc, imgAlt, onClick }) => {
    return (
        <button
            onClick={onClick}
            style={{ backgroundColor: "transparent", border: "none" }}
        >
            <img
                src={imgSrc}
                alt={imgAlt}
                style={{
                    width: "50px",
                    height: "50px",

                }}
            />
        </button>
    );
};

export default function Testimonials() {
    const settings = {
        dots: true,
        infinite: false,
        speed: 500,

        slidesToShow: 3,
        // slidesToScroll: 4,
        prevArrow: <PrevButton />,
        nextArrow: <NextButton />,
        responsive: [
            {
              breakpoint: 992,
              settings: {
                slidesToShow: 2,
               
              }
            },
            {
              breakpoint: 767,
              settings: {
                slidesToShow: 1,
               
              }
            }
           
          ],
        beforeChange: (current, next) => {
            console.log(next);
        }
    };
    return (

        <div className="pt-md-50 pb-40">

            <Slider {...settings}>
                <div className="slide">
                    <div className="test-bx p-3  me-md-4 me-0">
                        <div className="d-flex justify-content-between">
                            <div className="test-img mb-3">
                                <img src={user_1} alt="" />
                            </div>

                            <div className="test-ratings">
                                <BsStarFill />
                                <BsStarFill />
                                <BsStarFill />
                                <BsStarHalf />
                                <BsStar />
                            </div>
                        </div>
                        <div className="test-title">
                            <h3>Sunitha Andria, Bangalore</h3>
                            <p>We have Invested in VISTAPLOTS. Though we have Invested a very small amount in Real ESTATES the Advisors of the VISTAPLOTS are guiding us and helping to improve the portfolio of our Investments.</p>
                        </div>
                    </div>
                </div>

                <div className="slide">
                    <div className="test-bx p-3  me-md-4 me-0">
                        <div className="d-flex justify-content-between">
                            <div className="test-img mb-3">
                                <img src={user_1} alt="" />
                            </div>

                            <div className="test-ratings">
                                <BsStarFill />
                                <BsStarFill />
                                <BsStarFill />
                                <BsStarHalf />
                                <BsStar />
                            </div>
                        </div>
                        <div className="test-title">
                            <h3>Sunitha Andria, Bangalore</h3>
                            <p>We have Invested in VISTAPLOTS. Though we have Invested a very small amount in Real ESTATES the Advisors of the VISTAPLOTS are guiding us and helping to improve the portfolio of our Investments.</p>
                        </div>
                    </div>
                </div>
                <div className="slide">
                    <div className="test-bx p-3  me-md-4 me-0">
                        <div className="d-flex justify-content-between">
                            <div className="test-img mb-3">
                                <img src={user_1} alt="" />
                            </div>

                            <div className="test-ratings">
                                <BsStarFill />
                                <BsStarFill />
                                <BsStarFill />
                                <BsStarHalf />
                                <BsStar />
                            </div>
                        </div>
                        <div className="test-title">
                            <h3>Sunitha Andria, Bangalore</h3>
                            <p>We have Invested in VISTAPLOTS. Though we have Invested a very small amount in Real ESTATES the Advisors of the VISTAPLOTS are guiding us and helping to improve the portfolio of our Investments.</p>
                        </div>
                    </div>
                </div>
                <div className="slide">
                    <div className="test-bx p-3  me-md-4 me-0">
                        <div className="d-flex justify-content-between">
                            <div className="test-img mb-3">
                                <img src={user_1} alt="" />
                            </div>

                            <div className="test-ratings">
                                <BsStarFill />
                                <BsStarFill />
                                <BsStarFill />
                                <BsStarHalf />
                                <BsStar />
                            </div>
                        </div>
                        <div className="test-title">
                            <h3>Sunitha Andria, Bangalore</h3>
                            <p>We have Invested in VISTAPLOTS. Though we have Invested a very small amount in Real ESTATES the Advisors of the VISTAPLOTS are guiding us and helping to improve the portfolio of our Investments.</p>
                        </div>
                    </div>
                </div>
                <div className="slide">
                    <div className="test-bx p-3  me-md-4 me-0">
                        <div className="d-flex justify-content-between">
                            <div className="test-img mb-3">
                                <img src={user_1} alt="" />
                            </div>

                            <div className="test-ratings">
                                <BsStarFill />
                                <BsStarFill />
                                <BsStarFill />
                                <BsStarHalf />
                                <BsStar />
                            </div>
                        </div>
                        <div className="test-title">
                            <h3>Sunitha Andria, Bangalore</h3>
                            <p>We have Invested in VISTAPLOTS. Though we have Invested a very small amount in Real ESTATES the Advisors of the VISTAPLOTS are guiding us and helping to improve the portfolio of our Investments.</p>
                        </div>
                    </div>
                </div>

            </Slider>
        </div>
    );
}